import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroBanner from "./components/HeroBanner";
import CategoryNav from "./components/CategoryNav";
import HotArticles from "./components/HotArticles";
import { articles } from "@/mocks/articles";

const topArticles = articles.filter((a) => a.isTop);

const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "黑料王",
  url: "https://heiliaowang.com",
  description: "黑料王是专注娱乐圈内幕、明星黑料曝光的权威平台，汇聚最新、最劲爆的圈内黑料资讯，深扒明星私下真实一面，每日更新独家内幕。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://heiliaowang.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
  publisher: {
    "@type": "Organization",
    name: "黑料王",
    url: "https://heiliaowang.com",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "黑料王",
  url: "https://heiliaowang.com",
  description: "专注娱乐圈内幕、明星黑料曝光的权威平台",
  logo: "https://heiliaowang.com/logo.png",
  sameAs: [
    "https://weibo.com/heiliaowang",
    "https://weixin.qq.com/heiliaowang",
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="黑料王 - 最全娱乐圈黑料曝光平台"
        description="黑料王是专注娱乐圈内幕、明星黑料曝光的权威平台，汇聚最新、最劲爆的圈内黑料资讯，深扒明星私下真实一面，每日更新独家内幕，让你第一时间掌握最全黑料动态。"
        keywords="黑料王,娱乐圈黑料曝光,明星黑料大全,最新劲爆黑料,圈内内幕揭秘,明星私生活曝光,娱乐八卦黑料"
        canonicalUrl="https://heiliaowang.com"
      />

      <div className="min-h-screen bg-background-950 flex flex-col">
        <Navbar />
        <main>
          <HeroBanner topArticles={topArticles} />
          <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
            <CategoryNav />
            <HotArticles articles={articles} />

            <section className="py-8 md:py-10" aria-label="用户口碑">
              <div className="bg-background-900 border border-background-800/60 rounded-lg p-6 md:p-8 text-center">
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-100 mb-2">
                  为什么选择黑料王？
                </h3>
                <p className="text-sm text-foreground-500 mb-6">数百万用户的共同选择，娱乐圈真相的终极入口</p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="p-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10 mx-auto mb-3">
                      <i className="ri-shield-check-line text-lg text-accent-400"></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-200 mb-1">独家爆料</h4>
                    <p className="text-xs text-foreground-500">每天更新独家一手内幕</p>
                  </div>
                  <div className="p-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10 mx-auto mb-3">
                      <i className="ri-speed-line text-lg text-accent-400"></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-200 mb-1">极速更新</h4>
                    <p className="text-xs text-foreground-500">热点事件第一时间追踪报道</p>
                  </div>
                  <div className="p-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10 mx-auto mb-3">
                      <i className="ri-user-star-line text-lg text-accent-400"></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-200 mb-1">深度调查</h4>
                    <p className="text-xs text-foreground-500">专业团队深挖事实真相</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="py-8 md:py-10" aria-label="订阅提醒">
              <div className="relative rounded-lg overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-primary-500/20 to-accent-500/10"></div>
                <div className="relative p-6 md:p-8 text-center bg-background-900 border border-background-800/60 rounded-lg">
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-100 mb-2">
                    不错过任何劲爆黑料
                  </h3>
                  <p className="text-sm text-foreground-400 mb-4 max-w-md mx-auto">
                    关注黑料王，第一时间获取最新娱乐圈内幕和明星黑料动态
                  </p>
                  <a
                    href="#"
                    className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold px-6 py-3 rounded-full text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-notification-3-line"></i>
                    开启爆料提醒
                  </a>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>

      <script type="application/ld+json">{JSON.stringify(homepageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
    </>
  );
}